import React from "react";
import { useDispatch } from "react-redux";
import { actionError } from "../../redux/action/ActionActions";

export default function RenderInput({ onlyImage, onChange, inputRef }) {
  const dispatch = useDispatch();

  return (
    <input
      ref={inputRef}
      type="file"
      onChange={(e) => {
        const file = e.target.files[0];

        if (file) {
          if (onlyImage && !file.type.match(/image-*/)) {
            dispatch(actionError("등록할 수 없는 파일입니다."));
            return;
          }

          const fs = new FileReader();
          fs.onload = () => {
            onChange({
              uri: fs.result,
              file,
            });
          };
          fs.readAsDataURL(file);
        }
        e.target.value = "";
      }}
      style={{ display: "none" }}
      accept={onlyImage ? "image/*" : ""}
    />
  );
}
